import { regular } from "@fortawesome/fontawesome-svg-core/import.macro";
import React from "react";
import DashboardEventItem from "../../components/dashboard-event-item/DashboardEventItem.component";
import useWindowSize from "../../hooks/useWindowSize";
import Slider from "react-slick";
import "../../../node_modules/slick-carousel/slick/slick.css"; 
import DashboardEventItemMobile from "../../components/dashboard-event-item/DashboardEventItemMobile.component";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import moment from "moment";
import { addPad } from "../../utils/helperFn";

function NextArrow(props) {
  const { className, style, onClick } = props;
  return (
    <div
      className={className}
      style={{ ...style }}
      onClick={onClick}
    >
      <FontAwesomeIcon icon={regular('chevron-right')} className="text-blue-gray-700" />
    </div>
  );
}

function PrevArrow(props) {
  const { className, style, onClick } = props;
  return (
    <div
      className={className}
      style={{ ...style}}
      onClick={onClick}
    >
      <FontAwesomeIcon icon={regular('chevron-left')} className="text-blue-gray-700" />
    </div>
  );
}

const EventDashboardContainer = ({ t, data, refId }) => {
    const evData = [
        {
            title: !!data.nearestDeadline ? moment(data.nearestDeadline).format('MMM Do YYYY @ hh:mm A') : t('none') ,
            iconClass: regular('timer'),
            subTitle: t('nearest_deadline'),
            eventLink: !!data?.nearestDeadlineEventId ? `/event/${data.nearestDeadlineEventId}${refId ? `?refId=${refId}` : ''}` : '/',
            widthFactor: '4' 
        },
        {
            title: addPad(data.activeEventsCount),
            iconClass: regular('calendar'),
            subTitle: t('active_events'),
            widthFactor: '2'
        },
        {
            title: addPad(data.yetToStartEventsCount),
            iconClass: regular('clock'),
            subTitle: t('yet_to_start'),
            widthFactor: '2'
        },
        {
            title: addPad(data.completedEventsCount),
            iconClass: regular('check-circle'),
            subTitle: t('completed_events'),
            widthFactor: '2'
        },
    ];

    const windowSize = useWindowSize();

    // eslint-disable-next-line
    const [eventData, setEventData] = React.useState(evData);

    React.useEffect(() => {
      setEventData(evData);
    }, [t])

    const loadEventData = () => eventData.map((el, index) => <DashboardEventItem key={index} data={el} t={t} />)
    const loadMobileEventData = () => eventData.map((el, index) => <DashboardEventItemMobile key={index} data={el} t={t} />)

    const loadEventSlider = () => {
        const settings = {
            className: "slider variable-width cm-mobile-event-dash-slider",
            dots: false,
            infinite: false,
            centerMode: false,
            slidesToShow: 1,
            slidesToScroll: 1,
            variableWidth: true,
            nextArrow: <NextArrow />,
            prevArrow: <PrevArrow />
          };

        return <div>
        <Slider {...settings}>
          {loadMobileEventData()}
        </Slider>
      </div>
    }

    return(
        <div className="cm-event-dashboard-wrap bg-blue-gray-50 py-3 px-4 position-relative">
            {
                data.totalEventsCount !== 0 ?  
                windowSize.screenWidth > 1024 ? <div className="d-flex">{loadEventData()}</div> : loadEventSlider()
                : windowSize.screenWidth > 767 ? <DashboardEventItem isEmpty={true} t={t} />   : <DashboardEventItemMobile isEmpty={true} t={t} />    
                
            }
        </div>
    )
}

export default EventDashboardContainer;